import React from 'react';

import './style.scss';
import ic_report_problem from '../../img/ic_report_problem.svg'
import { Button } from 'reactstrap';
import SubHeader from  '../../components/Header/subHeader'
import { withTranslation } from 'react-i18next';
import { history } from '../../pages/index';

class LimitedAccess extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
        is_screll: false,
        DeviceCode:null,
        tosinfo:{}
    };
    this.handleClick = this.handleClick.bind(this);
  }
  
  handleClick(){
    history.push('/Subscribe');
  } 

  async componentDidMount(){
   
  }

  render (){
    const {t} = this.props
    return(
      <div className="inactive__main__screen error__default__screen d-flex flex-column h-100 align-items-center justify-content-center">
         <SubHeader className="mb-auto" title="Limited Access"/>
        <div className="inactive__inner__screen mb-auto">
            <div className="d-flex flex-column text-center inactive__inner__text text-center">
                <img className="mx-auto mb-5" alt="" src={ic_report_problem}/>
                <h1>A Thalamus subscription is required <br/>to access this area.</h1>
                <Button size="xl" onClick={() => this.handleClick()} className="mx-auto" color="default">Subscribe to Thalamus</Button>
            </div>
        </div>
      </div>
    ) 
  }
}
export default withTranslation('common')(LimitedAccess);
